import React from 'react';
import { Amplify } from 'aws-amplify';
import {
  Authenticator,
  ThemeProvider,
  Theme,
  useTheme,
  useAuthenticator,
} from '@aws-amplify/ui-react';
import AppContainer from '../AppContainer/AppContainer';
import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import InviteSplash from 'components/InviteSplash/InviteSplash';
import { generateAuthTheme, generateFooterChildren } from 'helpers/componentHelper';

import './App.scss';

import awsExports from 'aws-exports';
Amplify.configure(awsExports);

// top level app component
function App() {
  const { tokens } = useTheme();
  const theme: Theme = generateAuthTheme(tokens);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const [showInvite, setShowInvite] = React.useState(false);
  // eslint-disable-next-line
  const [showInviteSignup, setShowInviteSignup] = React.useState(false);
  const footerChildren = generateFooterChildren();
  React.useEffect(() => {
    setShowInvite(window?.location?.pathname === '/invite');
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className="app">
        {showInvite && <InviteSplash />}
        {showInviteSignup && (
          <div className="app__invite-signup">
            <Authenticator initialState="signUp" />
          </div>
        )}
        {!showInvite && !showInviteSignup && user === undefined && <Header />}
        {!showInvite && !showInviteSignup && user === undefined && (
          <div className="app__signin">
            <InviteSplash />
            <Authenticator hideSignUp={true} />
          </div>
        )}
        {!showInvite && !showInviteSignup && user === undefined && (
          <Footer children={footerChildren} />
        )}
        {!!user && <AppContainer user={user} signOut={signOut} />}
      </div>
    </ThemeProvider>
  );
}

export default App;
